/* ============================================================
   Kitopet — global.js
   Menu mobile · panier AJAX · quantités · galerie produit
   ============================================================ */
(function () {
  'use strict';

  var money = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';

  function formatMoney(cents) {
    try {
      var value = (cents / 100);
      return new Intl.NumberFormat(document.documentElement.lang || 'fr', {
        style: 'currency',
        currency: window.Shopify && Shopify.currency ? Shopify.currency.active : 'EUR'
      }).format(value);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  /* ---------- Menu mobile ---------- */
  function initMobileMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    if (!toggle) return;

    var backdrop = document.createElement('div');
    backdrop.className = 'nav-backdrop';
    document.body.appendChild(backdrop);

    function close() {
      document.body.classList.remove('nav-open');
      toggle.setAttribute('aria-expanded', 'false');
    }
    function open() {
      document.body.classList.add('nav-open');
      toggle.setAttribute('aria-expanded', 'true');
    }
    toggle.addEventListener('click', function () {
      document.body.classList.contains('nav-open') ? close() : open();
    });
    backdrop.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  /* ---------- Steppers de quantité ---------- */
  function initQuantity(root) {
    (root || document).querySelectorAll('[data-quantity]').forEach(function (wrap) {
      if (wrap.dataset.qtyBound) return;
      wrap.dataset.qtyBound = '1';
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('[data-qty-change]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-qty-change'), 10);
          var min = parseInt(input.min || '1', 10);
          var val = parseInt(input.value || '1', 10) + step;
          if (val < min) val = min;
          input.value = val;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Compteur panier ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) { el.removeAttribute('hidden'); }
      else { el.setAttribute('hidden', ''); }
    });
  }

  function refreshCart() {
    return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); return cart; })
      .catch(function () {});
  }

  /* ---------- Toast ---------- */
  var toastEl;
  function showToast(message, linkText, linkHref) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '';
    var span = document.createElement('span');
    span.textContent = message;
    toastEl.appendChild(span);
    if (linkText && linkHref) {
      var a = document.createElement('a');
      a.href = linkHref;
      a.textContent = linkText;
      toastEl.appendChild(a);
    }
    requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 4000);
  }

  /* ---------- Ajout au panier AJAX ---------- */
  function initAddToCart() {
    document.querySelectorAll('form.product-form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var original = btn ? btn.innerHTML : '';
        if (btn) { btn.setAttribute('disabled', ''); btn.innerHTML = '…'; }

        var addUrl = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js';
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify(serialize(form))
        })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (err) { throw err; });
            return r.json();
          })
          .then(function (item) {
            return refreshCart().then(function () {
              var cartUrl = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
              showToast(
                (item.product_title || 'Produit') + ' — ' + (document.documentElement.lang === 'en' ? 'added to cart' : 'ajouté au panier'),
                document.documentElement.lang === 'en' ? 'View cart' : 'Voir le panier',
                cartUrl
              );
            });
          })
          .catch(function (err) {
            showToast((err && err.description) || (document.documentElement.lang === 'en' ? 'Unable to add product.' : 'Impossible d\'ajouter le produit.'));
          })
          .finally(function () {
            if (btn) { btn.removeAttribute('disabled'); btn.innerHTML = original; }
          });
      });
    });
  }

  function serialize(form) {
    var data = { items: [] };
    var id = form.querySelector('[name="id"]');
    var qty = form.querySelector('[name="quantity"]');
    data.items.push({
      id: id ? parseInt(id.value, 10) : null,
      quantity: qty ? parseInt(qty.value, 10) || 1 : 1
    });
    return data;
  }

  /* ---------- Galerie produit ---------- */
  function initGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (main && full) { main.src = full; main.srcset = ''; }
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    initMobileMenu();
    initQuantity(document);
    initAddToCart();
    initGallery();
    refreshCart();
  });
})();
